import { useLocation } from 'react-router-dom'

import { usePostPaymentFlowConfig } from 'hooks/usePostPaymentFlowConfig'
import { useShouldShowPostPaymentProgressBar } from 'hooks/useShouldShowPostPaymentProgressBar'

import { getPageIdFromPathName } from 'helpers/getPageIdFromPathName'

import { PageId } from 'page-constants'

export const useIsEnhancedPostPaymentFlow = (): boolean => {
  const { pathname } = useLocation()
  const { pages } = usePostPaymentFlowConfig()
  const shouldShowProgressBar = useShouldShowPostPaymentProgressBar()

  const currentPageId = getPageIdFromPathName(pathname)
  const isPostPaymentPage = pages.includes(currentPageId as PageId)

  return isPostPaymentPage && shouldShowProgressBar
}
